module.exports = __webpack_public_path__ + "img/home-bg-with-coins.46eea385.png";